export class DepositSearchResult {
    constructor(
        public Check_Ref_Number: number = 0,
        public Payer_ShardPayerIdentifier: string = '',
        public Check_CheckNumber: string = '',
        public Check_CheckAmount: number = 0.00,
        public CheckStatus: string = '',
        public Deposit_DepositDate?: Date,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/models/depositSearchResult.model.ts